import { ExternalIcon, ExternalLink } from "./blocks";
import {
  bhfAllMonitorsUrl,
  purchaseDisclaimer,
  purchaseMonitors,
  PurchaseMonitor,
  retailerBrands,
} from "./purchase-monitors";
import "./HelpCentre.scss";

const MonitorCard = ({ monitor }: { monitor: PurchaseMonitor }) => {
  const retailers = monitor.retailers.filter((r) => r.url);

  return (
    <li className="nhsuk-grid-column-one-third nhsuk-card-group__item">
      <div className="nhsuk-card rs-monitor-card">
        <div className="rs-monitor-card__photo">
          {monitor.image ? (
            <img src={monitor.image} alt={monitor.name} />
          ) : (
            <span className="rs-monitor-card__photo-placeholder" aria-hidden="true" />
          )}
        </div>

        <div className="nhsuk-card__content">
          <h3 className="nhsuk-card__heading">{monitor.name}</h3>
          <p className="nhsuk-card__description">{monitor.description}</p>
          {monitor.price && (
            <p className="rs-monitor-card__price">Estimated cost: {monitor.price}</p>
          )}

          {retailers.length > 0 ? (
            <div className="rs-monitor-card__buy-group">
              <p className="rs-monitor-card__buy-label">Buy from</p>
              <div className="rs-monitor-card__buttons">
                {retailers.map((retailer) => {
                  const brand = retailerBrands[retailer.name];

                  return (
                    <a
                      key={retailer.name}
                      className="rs-monitor-card__buy"
                      href={retailer.url}
                      target="_blank"
                      rel="noreferrer noopener"
                      style={{ backgroundColor: brand?.background, color: brand?.text }}
                    >
                      <span aria-hidden="true">{brand?.shortName ?? retailer.name}</span>
                      <ExternalIcon />
                      <span className="nhsuk-u-visually-hidden">
                        Buy {monitor.name} from {retailer.name} (opens in a new window)
                      </span>
                    </a>
                  );
                })}
              </div>
            </div>
          ) : (
            <p className="rs-monitor-card__pending">Retailer links coming soon.</p>
          )}
        </div>
      </div>
    </li>
  );
};

// Purchase cards for the Buying a Blood Pressure Monitor page. Also used by the onboarding and
// take-readings wizards, so it stays self-contained - no routing, no page heading.
export const PurchaseCards = () => (
  <>
    <ul className="nhsuk-grid-row nhsuk-card-group rs-monitor-cards">
      {purchaseMonitors.map((monitor) => (
        <MonitorCard key={monitor.name} monitor={monitor} />
      ))}
    </ul>

    <p className="nhsuk-body-s rs-monitor-disclaimer">{purchaseDisclaimer}</p>

    <h2>Need more options?</h2>
    <p>
      Visit the{" "}
      <ExternalLink href={bhfAllMonitorsUrl}>
        British Heart Foundation validated monitor list
      </ExternalLink>
      .
    </p>
  </>
);

export default PurchaseCards;
